import React from 'react';
import PropTypes from 'prop-types';

import styles from './ratingDisplayV5.scss';

const CBRScale = ({ value, lightBg }) => {
    const values = ['R1', 'O1', 'O2', 'G1', 'G2', 'G3'];
    return (
        <div className={`${styles.colorBallScale} ${lightBg ? styles.lightBg : ''}`}>
            {values.map((val, i) => (
                <div className={`${styles.segment}`} key={val}>
                    <div className={`${styles.color} ${styles[val[0]]} ${i <= values.indexOf(value) ? styles.active : ''}`} />
                    <div className={`${styles.label} ${i === values.indexOf(value) ? styles.active : ''}`}>
                        {val}
                    </div>
                </div>
            ))}
        </div>
    );
};

CBRScale.defaultProps = {
    lightBg: false,
};

CBRScale.propTypes = {
    value: PropTypes.string.isRequired,
    lightBg: PropTypes.bool,
};

export default CBRScale;
